import { Button, Layout as LayoutAnt, Popover, Space } from "antd";
import { Typography } from "antd";
import {
  CaretDownOutlined,
  DoubleLeftOutlined,
  DoubleRightOutlined,
  LogoutOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import { logout } from "../services/user.service";
import { isMobile } from "react-device-detect";
import { useState } from "react";

const { Title, Text } = Typography;
const { Header } = LayoutAnt;

export default function HeaderCustom({
  title,
  user,
  collapsed,
  toggleCollapsed,
}: any) {
  const [openProfile, setOpenProfile] = useState<boolean>(false);

  const onLogout = () => {
    logout()
      .finally(() => {
        localStorage.removeItem("user");

        window.location.href = '/';
      })
  }
  const handleOpenProfileChange = (open: boolean) => {
    setOpenProfile(open);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {!isMobile && <Button
        onClick={toggleCollapsed}
        style={{
          position: "absolute",
          zIndex: "999",
          borderRadius: "50%",
          width: "32px",
          height: "32px",
          padding: "0px",
          marginLeft: "-16px"
        }}
      >
        {collapsed ? <DoubleRightOutlined /> : <DoubleLeftOutlined />}
      </Button>}
      <Header
        style={{
          width: "100%",
          background: "#FFFFFF",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          boxShadow: "0px 4px 6px -2px rgba(0, 0, 0, 0.2)",
          zIndex: 9,
          padding: 24
        }}
      >
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          alignItems: "center",
        }}>
          {isMobile && <Button
            onClick={toggleCollapsed}
            type="default" size="large"
          >
            {<MenuOutlined />}
          </Button>}

          <Title style={{ marginTop: 0, marginBottom: 0 }} level={4}>
            {title.split(' / ')[0]}
            {title.split(' / ')[1] && <span style={{ fontSize: 16, fontWeight: 400 }}> / {title.split(' / ')[1]}</span>}
          </Title>

          {isMobile ? (
            <Popover
              content={<div style={{ paddingLeft: 10, paddingRight: 10 }}>
                <a href="#" onClick={() => {
                  onLogout();
                }}>
                  <LogoutOutlined /> Sair
                </a>
              </div>}
              title={`Olá, ${user?.name}`}
              trigger="click"
              placement="bottom"
              open={openProfile}
              onOpenChange={handleOpenProfileChange}
            >
              <Button type="link" size="middle" style={{ color: '#333333' }} icon={<CaretDownOutlined />}></Button>
            </Popover>
          ) : (
            <Space>
              <Text>Olá, {user?.name}</Text>
              <a href="#" onClick={() => {
                onLogout();
              }}>
                <LogoutOutlined /> Sair
              </a>
            </Space>
          )}
        </div>
      </Header>
    </div>
  );
}
